import { fetchOptions } from './csrf'

export interface DealerDocSetting {
  id: string | null
  enabled: boolean
  api_key_set: boolean
  dealer_code: string | null
  auto_sync: boolean
  last_sync_at: string | null
  sync_status: string
  created_at: string | null
  updated_at: string | null
}

interface DealerDocSettingResponse {
  dealer_doc_setting: DealerDocSetting
}

interface ErrorResponse {
  errors: string[]
}

export const dealerDocSettingsApi = {
  async show(): Promise<DealerDocSetting> {
    const response = await fetch('/api/v1/settings/dealerdoc', fetchOptions())
    if (!response.ok) throw new Error('Failed to load DealerDoc settings')
    const data: DealerDocSettingResponse = await response.json()
    return data.dealer_doc_setting
  },

  async update(params: { enabled?: boolean; api_key?: string; dealer_code?: string; auto_sync?: boolean }): Promise<DealerDocSetting> {
    const response = await fetch('/api/v1/settings/dealerdoc', {
      ...fetchOptions('PUT'),
      body: JSON.stringify({ dealer_doc_setting: params }),
    })
    if (!response.ok) {
      const data: ErrorResponse = await response.json().catch(() => ({ errors: ['Failed to update settings'] }))
      throw new Error(data.errors.join(', '))
    }
    const data: DealerDocSettingResponse = await response.json()
    return data.dealer_doc_setting
  },
}
